Upload a document to this load


<app-file-upload *appHasRoles="['admin', 'partner', 'finance_manager']" (upload)="triggerOnUpload($event)"></app-file-upload>
